/**
 * Shared defaults for Agent queries
 * 
 * These defaults ensure consistency between:
 * - useAgentsQuery hook
 * - useBootstrapAgentsData prefetch hook
 * - AgentsPage component initial state
 * 
 * This guarantees that the prefetch query key exactly matches
 * the initial Agents page query, so cached data is used immediately.
 */

import { AgentsQueryParams } from './useAgentsQuery';

export const DEFAULT_AGENT_PAGE = 1;
export const DEFAULT_AGENT_PAGE_SIZE = 10; // Default page size (minimum 10)
export const AGENT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;

/**
 * Default query parameters for Agent list queries
 * 
 * These are used for:
 * - Initial Agents page load
 * - Bootstrap prefetch (first page only, lightweight)
 * - Fallback values in useAgentsQuery
 * 
 * IMPORTANT: All optional fields are explicitly set to undefined
 * to ensure query key consistency (undefined vs missing = different keys).
 */
export const DEFAULT_AGENT_QUERY_PARAMS: AgentsQueryParams = {
  page: DEFAULT_AGENT_PAGE,
  limit: DEFAULT_AGENT_PAGE_SIZE,
  search: '',
  status: undefined,
  role: undefined,
  sort: undefined,
};

